// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"6f0b48a7","137":"717b364c","167":"239b9620","428":"2bfdea90","568":"f9b66860","865":"0c77ff2a","872":"820da33e","921":"8e3e89f4"}[chunkId] + ".chunk.js";
};